import { render, staticRenderFns } from "./AllNonConformities.vue?vue&type=template&id=1423afda&"
import script from "./AllNonConformities.vue?vue&type=script&lang=js&"
export * from "./AllNonConformities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports